import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const SupplierInfo: React.FC = () => {
  return (
    <Box>
      <img 
        src="/assets/image/logo.png" 
        alt="Company Logo" 
        className="company-logo"
        style={{ maxHeight: '80px', objectFit: 'contain', marginBottom: '1rem' }}
      />
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        William Lécuyer
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Maître Électricien,<br />
        Groupe Pro-L
      </Typography>

      <Box className="contact-info-container" sx={{ 
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box className="contact-item" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">📞</Typography>
          <Link 
            href="tel:450-236-0219" 
            color="inherit" 
            underline="none"
            sx={{ 
              color: 'text.primary',
              '&:hover': { color: 'primary.main' }
            }}
          >
            450-236-0219
          </Link>
        </Box>
        
        <Box className="contact-item" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">🌐</Typography>
          <Link 
            href="https://groupeprol.com" 
            color="inherit" 
            underline="none"
            sx={{ 
              color: 'text.primary',
              '&:hover': { color: 'primary.main' }
            }}
          >
            groupeprol.com
          </Link>
        </Box>
        
        <Box className="contact-item" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">✉️</Typography>
          <Link 
            href="mailto:william.lecuyer@groupeprol.com" 
            color="inherit" 
            underline="none"
            sx={{ 
              color: 'text.primary',
              '&:hover': { color: 'primary.main' }
            }}
          >
            william.lecuyer@groupeprol.com
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default SupplierInfo; 